import 'moment-timezone/builds/moment-timezone-with-data-1970-2030';
import moment from "moment";
var LotteryDateHelper = /** @class */ (function () {
    function LotteryDateHelper(item) {
        this.item = item;
        //if (item.currentJackpotDraw && item.timezone)
        //    this.setCurrentJackpotDraw(item.currentJackpotDraw.drawDate, item.drawTimeHours, item.drawTimeMinutes, item.timezone);
    }
    Object.defineProperty(LotteryDateHelper.prototype, "drawDate", {
        //drawDate
        get: function () {
            return this.getCurrentJackpotDrawInLocalTime(this.item);
        },
        set: function (x) {
            if (this.item && this.item.currentJackpotDraw && this.item.timezone) {
                this.setCurrentJackpotDraw(x, this.item.drawTimeHours, this.item.drawTimeMinutes, this.item.timezone);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryDateHelper.prototype, "drawTimeHours", {
        get: function () {
            return this.item ? this.item.drawTimeHours : 0;
        },
        set: function (x) {
            this.item.drawTimeHours = x;
            this.setCurrentJackpotDraw(this.drawDate, x, this.item.drawTimeMinutes, this.item.timezone);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryDateHelper.prototype, "drawTimeMinutes", {
        get: function () {
            return this.item ? this.item.drawTimeMinutes : 0;
        },
        set: function (x) {
            this.item.drawTimeMinutes = x;
            this.setCurrentJackpotDraw(this.drawDate, this.item.drawTimeHours, x, this.item.timezone);
        },
        enumerable: false,
        configurable: true
    });
    LotteryDateHelper.prototype.getCurrentJackpotDrawInLocalTime = function (item) {
        if (item && item.currentJackpotDraw && item.currentJackpotDraw.drawDate && item.timezone) {
            var dateForHoursAndMinutes = moment(new Date());
            var momentTz = dateForHoursAndMinutes.tz(item.timezone);
            momentTz.hour(item.drawTimeHours);
            momentTz.minute(item.drawTimeMinutes);
            momentTz.second(0);
            var utcMinutesAndHours = new Date(momentTz.toJSON());
            var dbDate = new Date(item.currentJackpotDraw.drawDate);
            dbDate.setHours(utcMinutesAndHours.getHours());
            dbDate.setMinutes(utcMinutesAndHours.getMinutes());
            dbDate.setSeconds(0);
            var date = moment(dbDate);
            return date.tz(item.timezone).toDate();
        }
        return null;
    };
    LotteryDateHelper.prototype.setCurrentJackpotDraw = function (date, drawTimeHours, drawTimeMinutes, timezone) {
        var time = moment;
        var uiDate = time.tz(date, timezone);
        uiDate.hour(drawTimeHours);
        uiDate.minute(drawTimeMinutes);
        uiDate.second(0);
        if (this.item.currentJackpotDraw) {
            this.item.currentJackpotDraw.drawDate = new Date(uiDate.toJSON());
            this.item.currentJackpotDraw.lotteryLocalDrawDate = uiDate.format("YYYY-MM-DD");
        }
    };
    LotteryDateHelper.prototype.getDay = function (current, previous, next) {
        if (this.item && this.item.timezone) {
            var utcDate = this.item.currentJackpotDraw && this.item.currentJackpotDraw.drawDate ? this.item.currentJackpotDraw.drawDate : new Date();
            var utc = moment(utcDate).format("DD/MM/YYYY");
            var local = moment(this.drawDate).tz(this.item.timezone).format("DD/MM/YYYY");
            if (utc == local) // if its same day
                return this.item[current];
            if (utc > local) // if its next day
                return this.item[next];
            if (utc < local) // if its previous day
                return this.item[previous];
        }
        return false;
    };
    LotteryDateHelper.prototype.setDay = function (current, previous, next, value) {
        if (this.item && this.item.timezone) {
            var utcDate = this.item.currentJackpotDraw && this.item.currentJackpotDraw.drawDate ? this.item.currentJackpotDraw.drawDate : new Date();
            var utc = moment(utcDate).format("DD/MM/YYYY");
            var local = moment(this.drawDate).tz(this.item.timezone).format("DD/MM/YYYY");
            if (utc == local) // if its same day
                this.item[current] = value;
            if (utc > local) // if its next day
                this.item[next] = value;
            if (utc < local) // if its previous day
                this.item[previous] = value;
        }
    };
    Object.defineProperty(LotteryDateHelper.prototype, "sunday", {
        //sunday
        get: function () {
            return this.getDay("sunday", "saturday", "monday");
        },
        set: function (x) {
            this.setDay("sunday", "saturday", "monday", x);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryDateHelper.prototype, "monday", {
        //monday
        get: function () {
            return this.getDay("monday", "sunday", "tuesday");
        },
        set: function (x) {
            this.setDay("monday", "sunday", "tuesday", x);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryDateHelper.prototype, "tuesday", {
        //tuesday
        get: function () {
            return this.getDay("tuesday", "monday", "wednesday");
        },
        set: function (x) {
            this.setDay("tuesday", "monday", "wednesday", x);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryDateHelper.prototype, "wednesday", {
        //wednesday
        get: function () {
            return this.getDay("wednesday", "tuesday", "thursday");
        },
        set: function (x) {
            this.setDay("wednesday", "tuesday", "thursday", x);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryDateHelper.prototype, "thursday", {
        //thursday
        get: function () {
            return this.getDay("thursday", "wednesday", "friday");
        },
        set: function (x) {
            this.setDay("thursday", "wednesday", "friday", x);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryDateHelper.prototype, "friday", {
        //friday
        get: function () {
            return this.getDay("friday", "thursday", "saturday");
        },
        set: function (x) {
            this.setDay("friday", "thursday", "saturday", x);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryDateHelper.prototype, "saturday", {
        //saturday
        get: function () {
            return this.getDay("saturday", "friday", "sunday");
        },
        set: function (x) {
            this.setDay("saturday", "friday", "sunday", x);
        },
        enumerable: false,
        configurable: true
    });
    return LotteryDateHelper;
}());
export { LotteryDateHelper };
